import lambdaApi from 'api/LambdaApi';
import { AxiosError } from 'axios';
import {
    ProfileSkillsUpdatePayload,
    ResumeProfileBaseModel,
    ResumeProfileModel,
} from 'generated-types/skills/resume_profile';
import { useMutation, useQuery } from 'react-query';

import {
    getExtIntQueryKey,
    resumeProfileMembersPrefix,
    resumeProfilesPrefix,
    skillsDBPrefix,
} from '.';

export const useResumeProfilesHook = (
    member_id?: number,
    resume_profile_id?: string,
    isExternal?: boolean,
) => {
    let getUri: string;
    let putUri: string;
    let skillsPutUri: string;

    if (isExternal) {
        getUri = `${skillsDBPrefix}/ext/resume_profiles`;
        putUri = `${skillsDBPrefix}/ext/resume_profiles`;
        skillsPutUri = `${skillsDBPrefix}/ext/resume_profiles/skills`;
    } else {
        getUri = `${resumeProfileMembersPrefix}/${member_id}/resume_profiles`;
        putUri = `${resumeProfilesPrefix}/${resume_profile_id}`;
        skillsPutUri = `${resumeProfilesPrefix}/${resume_profile_id}/skills`;
    }

    const {
        data: resumeProfiles,
        isLoading: isLoadingResumeProfiles,
        refetch: refetchResumeProfiles,
    } = useQuery<ResumeProfileModel[]>(
        ['member_resume_profiles', getExtIntQueryKey(isExternal), member_id],
        () => lambdaApi.get(getUri, {}).then(res => res.data),
        {
            retry: false,
            enabled: member_id !== undefined,
        },
    );

    const updateResumeProfile = useMutation<ResumeProfileModel, AxiosError, ResumeProfileBaseModel>(
        payload => {
            return lambdaApi.put(putUri, payload).then(res => res.data);
        },
    );

    const createResumeProfile = useMutation<ResumeProfileModel, AxiosError, ResumeProfileBaseModel>(
        payload => {
            return lambdaApi.post(getUri, payload).then(res => res.data);
        },
    );

    const deleteResumeProfile = useMutation<void, AxiosError, void>(async () => {
        await lambdaApi.delete(`${putUri}`);
        return undefined;
    });

    const updateResumeProfileSkills = useMutation<
        ProfileSkillsUpdatePayload,
        AxiosError,
        ProfileSkillsUpdatePayload
    >(payload => {
        return lambdaApi.put(skillsPutUri, payload).then(res => res.data);
    });

    return {
        createResumeProfile,
        updateResumeProfile,
        updateResumeProfileSkills,
        deleteResumeProfile,
        isLoadingResumeProfiles,
        refetchResumeProfiles,
        resumeProfiles,
    };
};
